import { createRouter, createWebHashHistory } from "vue-router";

// export default createRouter({
  // history: createWebHashHistory(),
 const routes= [
  {
    path:'/',
    redirect:'/PayLogin',
    meta:{
      title:'充值中心 - U.LU Games'
    }
  },
    
    {
      path:"/PayLogin",
      name:'PayLogin',
      component:()=>import('./components/PayHome/PayLogin.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('./components/404.vue')
  },
  {
      path: '/:pathMatch(.*)',
      redirect: '/404'
  },
  ]
const router = createRouter({
  history:createWebHashHistory(),
  routes
})
// router.beforeEach((to,from,next)=>{
//   let token = localStorage.getItem('token')
//     if(to.name !='PayHome' && !token) next({name:'PayLogin'});
//     else next()
  
// })
export default router
